module.exports = __webpack_public_path__ + "img/1535049697.b7181ebc.jpg";